import { createSlice } from "@reduxjs/toolkit";

import { getAnalysisByScanId, getMetadataByScanId } from "../actions";
import { convertScoringHitsToTree } from "../utils";

const INITIAL_STATE = {
  isDirty: false,
  content: [],
  metadata: null,
  tree: [],
  numberOfElements: 0,
  totalElements: 0,
  totalPages: 0,
  scoringUnavailable: false,
  isRescanning: false,
  selectedTermHash: null,
};

const mergeDataIntoState = (state, { payload }) => {
  state.content = payload?.content || [];
  state.tree = convertScoringHitsToTree(payload?.content);
  state.numberOfElements = payload?.numberOfElements || 0;
  state.totalElements = payload?.totalElements || 0;
  state.totalPages = payload?.totalPages || 0;
};

export const scoringAnalysisSlice = createSlice({
  name: "analysis",
  initialState: INITIAL_STATE,
  reducers: {
    resetScoring: () => INITIAL_STATE,
    setScoringUnavailable: (state, { payload }) => {
      state.scoringUnavailable = payload;
    },
    setIsRescanning: (state, { payload }) => {
      state.isRescanning = payload;
    },
    setSelectedTermHash: (state, { payload = null }) => {
      state.selectedTermHash = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAnalysisByScanId.fulfilled, (state, action) => {
      mergeDataIntoState(state, action);
      if (action.payload) {
        state.scoringUnavailable = false;
      }
    });

    builder.addCase(getMetadataByScanId.fulfilled, (state, { payload }) => {
      state.metadata = payload || null;
      if (payload) {
        state.scoringUnavailable = false;
      }
    });
  },
});

export const {
  resetScoring,
  setScoringUnavailable,
  setIsRescanning,
  setSelectedTermHash,
} = scoringAnalysisSlice.actions;

export default scoringAnalysisSlice.reducer;
